import { G } from '@/components/gold/theme'
import styled, { keyframes } from 'styled-components'

export const Wrap = styled.div`
  width: 100%;
  min-height: 100dvh;
  background: #000;
  flex-shrink: 0;
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  position: relative;
`

export const ParallaxBg = styled.div`
  width: 100% !important;
  left: 50%;
  transform: translateX(-50%);
`

export const Layer = styled.div`
  &.m-layer .orb-1 { width: 150px; height: 150px; top: 50%; left: -10%; }
  &.m-layer .orb-2 { width: 200px; height: 200px; top: 10%; right: -10%; }
  &.m-layer .orb-3 { width: 500px; height: 500px; bottom: -30%; right: -30%; }
  &.m-layer .orb-4 { width: 330px; height: 330px; bottom: -80%; left: -30%; }
  &.m-layer .suit-1 { top: 55%; left: -10%; width: 30%; }
  &.m-layer .suit-2 { top: 30%; right: -10%; width: 50%; }
  &.m-layer .suit-3 { top: 100%; right: -10%; width: 30%; }
  &.m-layer .suit-4 { bottom: -55%; left: -10%; width: 50%; }
  &.m-layer .suit-5 { bottom: -75%; left: -10%; width: 50%; }
  &.m-layer .suit-1 img,
  &.m-layer .suit-2 img,
  &.m-layer .suit-3 img,
  &.m-layer .suit-4 img,
  &.m-layer .suit-5 img { max-width: 100%; }
`

export const ContentArea = styled.div`
  padding: 80px 0 100px 0;
  width: 90%;
  margin: 0 auto;
  position: relative;
  z-index: 10;
`

const scrollAnim = keyframes`
  0%   { transform: translateX(500px); }
  100% { transform: translateX(-100%); }
`

export const ScrollNotice = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  margin: 0 auto;
  background: #f5a623;
  color: #000;
  font-size: 13px;
  font-weight: 600;
  overflow: hidden;
  white-space: nowrap;
  padding: 8px 0;
  z-index: 9999;
`

export const ScrollNoticeTrack = styled.span`
  display: inline-block;
  animation: ${scrollAnim} 20s linear infinite;
`

/* ---------- ver2(gold) 모바일 ---------- */
export const GoldWrap = styled.div`
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  min-height: 100vh;
  background: ${G.mBg};
`

export const GoldBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-bottom: 40px;
  width: 100%;
  overflow-x: hidden;
  & > * { min-width: 0; }
`

export const GoldNewsWrap = styled.div`
  padding: 0 9px;
`
